import clsx from "clsx";
import { useTranslation } from "react-i18next";

export default function CaseSection() {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language === "zh";

  const cases = t("home.case.items", {
    returnObjects: true,
  }) as Array<{ title: string; description: string; animation: string }>;

  return (
    <div className="bg-[#f2f4f6] relative w-full pt-10 md:pt-[60px] pb-8 md:pb-[40px]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-5">
        <h2
          data-aos-delay="100"
          data-aos="fade-up"
          className="font-bold text-[#222] text-[26px] md:text-[34px] text-center pb-[16px] md:pb-[20px] leading-tight"
        >
          {t("home.case.title")}
        </h2>
        <p data-aos="fade-up" className="text-center text-[#666] text-[15px] md:text-[18px] leading-relaxed px-2">
          {t("home.case.subtitle")}
        </p>
        <div className="min-h-0 md:h-auto my-8 md:my-[60px] relative w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-[20px]">
          {cases.map((item, index) => {
            const iconIndex = String(index + 17);
            const iconUrl = `images/index${iconIndex}.png`;

            return (
              <div
                key={index}
                data-aos={item.animation}
                className="min-h-[220px] bg-white"
              >
                <i
                  className="w-full h-[120px] md:h-[140px] bg-no-repeat bg-center bg-contain block"
                  style={{ backgroundImage: `url(${iconUrl})` }}
                ></i>
                <h3
                  className={clsx(
                    "px-5 pt-4 md:pt-5 pb-2 font-bold text-[#111113] whitespace-normal md:whitespace-nowrap leading-snug",
                    isZh ? "text-[16px] md:text-[18px]" : "text-[15px] md:text-[16px]"
                  )}
                >
                  {item.title}
                </h3>
                <p className="text-left text-[14px] text-[#666] px-5 pb-[15px] leading-[22px]">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
